import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import PriceDropIcon from '@adv-mt/mt-svg-icons/lib/PriceDrop'

const TEST_ID_LABEL_PRICE_DROP = 'labelPriceDrop-container'

const LabelPriceDrop = ({amount}) => {
  const {i18n} = useContext(Context)

  const priceDropAmount = i18n.c(amount)

  return amount ? (
    <div className="mt-LabelPriceDrop" data-testid={TEST_ID_LABEL_PRICE_DROP}>
      <PriceDropIcon />
      <span className="mt-LabelPriceDrop-text">{i18n.t('COMMON.PRICE_DROP.LABEL', {priceDrop: priceDropAmount})}</span>
    </div>
  ) : null
}

LabelPriceDrop.displayName = 'LabelPriceDrop'
LabelPriceDrop.propTypes = {
  amount: PropTypes.number
}

export default LabelPriceDrop
